import { PHOTO_BUTTON } from "../constants"

import LoaderElement from "./loader-element"
import ImageElement from "./image-element"
import TitleElement from "./title-element"
import DescriptionElement from "./description-element"
import AuthorElement from "./author-element"
import TimestampElement from "./timestamp-element"
import StarsElement from "./stars-element"
import CommentListElement from "./comment-list-element"
import FormCommentElement from "./form-comment-element"
import ButtonElement from "./button-element"
import ContainerElement from "./container-element"
import HindcastElement from "./hindcast-element"
import TidesElement from "./tides-element"

class View {
  constructor(context, htmlElement, location, token) {
    this._context = context

    // Initialize all view elements
    this.container = ContainerElement.fromHtmlElement(htmlElement)
    this.loader = LoaderElement.fromHtmlElement(htmlElement)
    this.imageElement = ImageElement.fromHtmlElement(htmlElement)
    this.titleElement = TitleElement.fromHtmlElement(htmlElement)
    this.descriptionElement = DescriptionElement.fromHtmlElement(htmlElement)
    this.authorElement = AuthorElement.fromHtmlElement(htmlElement)
    this.timestampElement = TimestampElement.fromHtmlElement(htmlElement)
    this.starsElement = StarsElement.fromHtmlElement(htmlElement)
    this.commentListElement = CommentListElement.fromHtmlElement(htmlElement)
    this.formCommentElement = FormCommentElement.fromHtmlElement(htmlElement)
    this.hindcastElement = HindcastElement.fromHtmlElement(htmlElement, location, token)
    this.tidesElement = TidesElement.fromHtmlElement(htmlElement, location, token)

    // Initialize buttons
    this.buttonElementList = Array.from(htmlElement.querySelectorAll(PHOTO_BUTTON)).map(
      (buttonNode) => new ButtonElement(buttonNode, buttonNode.dataset.direction),
    )

    // Wire up event handlers
    if (this.container) {
      this.container.onClick(() => context.photosButtonsVisibilityUpdated())
    }
    this.imageElement.onLoad(() => context.photosLoaded())
    this.buttonElementList.forEach((button) => {
      button.onClick((direction) => context.photosLoadRequested(direction))
    })
  }

  update(state) {
    // Update loader
    if (this.loader) {
      this.loader.toggleVisibility(state.loading)
    }

    // Update buttons
    this.buttonElementList.forEach((button) => {
      button.toggleDisableState(state.loading)

      if (button.direction === "backward") {
        button.toggleVisibility(state.backwardPhoto === null)
      }
      if (button.direction === "forward") {
        button.toggleVisibility(state.forwardPhoto === null)
      }
    })

    // Update photo content
    if (state.currentPhoto !== null) {
      this.updateUrl(state.currentPhoto)
      if (this.imageElement) this.imageElement.apply(state.currentPhoto)
      if (this.titleElement) this.titleElement.apply(state.currentPhoto)
      if (this.descriptionElement) this.descriptionElement.apply(state.currentPhoto)
      if (this.authorElement) this.authorElement.apply(state.currentPhoto)
      if (this.timestampElement) this.timestampElement.apply(state.currentPhoto)
      if (this.starsElement) this.starsElement.apply(state.currentPhoto)
      if (this.commentListElement) this.commentListElement.apply(state.currentPhoto)
      if (this.formCommentElement) this.formCommentElement.apply(state.currentPhoto)
      if (this.hindcastElement) this.hindcastElement.apply(state.currentPhoto)
      if (this.tidesElement) this.tidesElement.apply(state.currentPhoto)
    }
  }

  updateUrl(photo) {
    if (window.history.state === null || window.history.state.photoId !== photo.id) {
      const url = window.location.pathname
        .split("/")
        .slice(0, -1)
        .concat([photo.id.toString()])
        .join("/")
      window.history.replaceState({ photoId: photo.id }, "", url)
    }
  }
}

export default View
